import CallCenterHome from "../../images/homesectionimages/CallCenterPhoto.png";
import FinanceHome    from "../../images/homesectionimages/FinancePhoto.png";
import HealthHome     from "../../images/homesectionimages/HealthCompliancePhoto.png";
import TechHome       from "../../images/homesectionimages/TechPhoto.webp";



//mobiletablet
 import CallCenterHomeTab from  "../../images/tabletImages/CallCenterPhotoT.png"; 
 import FinanceHomeTab   from   "../../images/tabletImages/FinancePhotoT.png";
 import HealthHomeTab   from "../../images/tabletImages/HealthCompliancePhotoT.png";
 import TechHomeTab     from "../../images/tabletImages/TechPhotoT.webp";





//mobileimage 

 import CallCenterHomeMob from  "../../images/mobileImages/CallCenterPhoto.png"; 
 import FinanceHomeMob    from   "../../images/mobileImages/FinancePhoto.png";
 import HealthHomeMob     from "../../images/mobileImages/HealthCompliancePhoto.png";
 import TechHomeMob       from "../../images/mobileImages/TechStaffingPhoto.webp";



export const section=[
{
 id:1,
 special: true,
 title: `Tech Staffing`,
 text:"Expedient recruits highly skilled IT pros— and we do it quickly",
 altt:"a hand on laptop, screen with code",
 place: "techstaffing",
 img:TechHome,
 imgm:TechHomeMob,
 imgt:TechHomeTab   
    
},

{
 id:2,
 special: false,
 title: `Finance Staffing`,
 text:"From Accounting to Financial Analysts— we crunche the numbers to secure top talent.", 
 altt:"a hand on calculator",   
 place: "financestaffing",
 img:FinanceHome,
 imgm:FinanceHomeMob,
 imgt:FinanceHomeTab 

},

{
 id:3,
 special: true,
 title: `Call Center Staffing`,
 text:"Need agents that can handle high call volume while maintaining quality? We deliver skills that get results.",
 altt:"staffing using a headset",
 place: "callcenterstaffing",  
 img:CallCenterHome,
 imgm:CallCenterHomeMob,
 imgt:CallCenterHomeTab
},

{
 id:4,
 special: true,
 title: `Health Compliance`,
 text:"Our compliance SMEs guide you toward workplace safety by preventing exposure to Covid-19 and other airborne diseases.",
 altt:"person in mask standing outside",
 place: "healthcompliance",    
 img:HealthHome,
 imgm:HealthHomeMob,
 imgt:HealthHomeTab
   
    },
];
